import {
  INSPECT_DUE_BEFORE_NOW,
  INSPECT_DUE_FROM_NOW,
  INSPECT_STATUS_UPCOMING,
} from 'config/constants';

// Splits a token on dashes/underscores and capitalizes each word:
// 'due-date' -> 'Due Date', 'pass' -> 'Pass'. Shared by the column-key
// fallback labels and the selector-column chip values below.
function titleCaseWords(token) {
  var parts = String(token || '').split(/[-_]/);
  var words = [];
  for (var i = 0; i < parts.length; i++) {
    if (!parts[i]) continue;
    words.push(parts[i].charAt(0).toUpperCase() + parts[i].slice(1));
  }
  return words.join(' ');
}

// Fallback label for a column key with no loaded descriptor, e.g. a filter
// preset by a Performance KPI click on a cold session before the first
// History/Scheduled response delivers the descriptors: 'due-date' -> 'Due Date'.
function humanizeColumnKey(key) {
  return titleCaseWords(key);
}

// Chip value display. The sentinels are stored values, not display text, and
// their wording is fixed: the due-date sentinels show the same wording
// DateFilterPopover uses, and the upcoming status sentinel (expanded to
// due-soon OR scheduled in the filter DTO) renders comma-separated, matching
// a manual multi-select of the same two statuses. The result and status
// selector columns store raw lowercase API values, so those render Title Case
// ('pass' -> 'Pass', 'due-soon' -> 'Due Soon'). Every other column's value
// (user-typed text filters, dates) displays verbatim.
function filterValueDisplay(value, columnKey) {
  if (Array.isArray(value)) {
    var parts = [];
    for (var i = 0; i < value.length; i++) {
      parts.push(filterValueDisplay(value[i], columnKey));
    }
    return parts.join(', ');
  }
  if (value === INSPECT_DUE_BEFORE_NOW) return 'Due Before Now';
  if (value === INSPECT_DUE_FROM_NOW) return 'Due Now and Later';
  if (value === INSPECT_STATUS_UPCOMING) return 'Due Soon, Scheduled';
  if (columnKey === 'result' || columnKey === 'status')
    return titleCaseWords(value);
  return String(value);
}

// Chips for one tab's active column filters: [{ key, label, value }]. Chips
// follow descriptor order so the row reads left-to-right like the table;
// filters without a loaded descriptor come last with a humanized key. The
// 'timestamp' column label is overridden the same way InspectRecords does.
export function buildFilterChips(columnFilters, descriptors, t) {
  var chips = [];
  if (!columnFilters) return chips;

  var pending = {};
  var pendingKeys = [];
  var keys = Object.keys(columnFilters);
  for (var i = 0; i < keys.length; i++) {
    var value = columnFilters[keys[i]];
    if (
      value === '' ||
      value === null ||
      value === undefined ||
      (Array.isArray(value) && value.length === 0)
    )
      continue;
    pending[keys[i]] = value;
    pendingKeys.push(keys[i]);
  }

  var list = descriptors || [];
  for (var d = 0; d < list.length; d++) {
    var descriptor = list[d];
    if (!pending.hasOwnProperty(descriptor.key)) continue;
    var label =
      descriptor.key === 'timestamp' && t
        ? t('inspect:dateColumnLabel')
        : descriptor.name;
    chips.push({
      key: descriptor.key,
      label: label || humanizeColumnKey(descriptor.key),
      value: filterValueDisplay(pending[descriptor.key], descriptor.key),
    });
    delete pending[descriptor.key];
  }

  for (var p = 0; p < pendingKeys.length; p++) {
    if (!pending.hasOwnProperty(pendingKeys[p])) continue;
    chips.push({
      key: pendingKeys[p],
      label: humanizeColumnKey(pendingKeys[p]),
      value: filterValueDisplay(pending[pendingKeys[p]], pendingKeys[p]),
    });
  }

  return chips;
}
